module.exports = __webpack_public_path__ + "img/Group_3_2.9bfab0aa.png";